import { createRoot } from 'react-dom/client';
import ReactModal from 'react-modal';

import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'url-polyfill';

import App from './App';
import { loadObservability } from './helpers/observability';

loadObservability();

const container = document.getElementById('root') as HTMLElement;
const root = createRoot(container);
root.render(<App />);
ReactModal.setAppElement('#root');
